var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { ICellEditorParams } from 'ag-grid-community';
import { FxAgGridValidationEditorComponent } from './fx-ag-grid-validation-editor';
import { FormBuilder, FormControl } from '@angular/forms';
import { DwDatePickerComponent } from 'ng-quicksilver';
import { FxAgGridEventHandlerService } from './fx-ag-grid-event-handler.service'; // Added by David Lee 25Feb2019
var FxAgGridDateEditorComponent = /** @class */ (function (_super) {
    __extends(FxAgGridDateEditorComponent, _super);
    function FxAgGridDateEditorComponent(fb, eventHandler) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.eventHandler = eventHandler;
        _this.dateFormat = 'YYYY/MM/DD';
        _this.flag = true;
        return _this;
    }
    FxAgGridDateEditorComponent.prototype.agInit = function (params) {
        var _this = this;
        this.editType = params.api.gridOptionsWrapper.gridOptions.editType || '';
        this.colId = params.column.getColId();
        this.validateForm = params.form;
        this.dateFormat = params.dateFormat ? params.dateFormat : this.dateFormat;
        var currentDate = moment(moment(params.value, this.dateFormat).toDate()).isValid() ? moment(params.value, this.dateFormat).toDate() : null;
        this.formControl = new FormControl(currentDate, params.validators);
        this.params = params; // 把cellEditorParams参数赋给params Added By David Lee 18Feb2019
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.name = this.params.node.id + '-' + params.column.colId;
        if (this.validateForm.contains(this.name)) {
            this.validateForm.setControl(this.name, this.formControl);
        }
        else {
            this.validateForm.addControl(this.name, this.formControl);
        }
        this.formControl.markAsDirty();
        // 监听赋值 Add David lee 25 Feb 2019
        this.valueSetSubscription = this.eventHandler.valueSet.subscribe(function (event) {
            if ((event.colId === _this.colId) && (event.gridId === params.context.id)) {
                _this.formControl.setValue(event.value);
                _this.message = event.message;
                _this.formControl.markAsDirty();
            }
        });
        _super.prototype.init.call(this);
    };
    FxAgGridDateEditorComponent.prototype.getValue = function () {
        return moment(this.formControl.value, this.dateFormat).format(this.dateFormat);
    };
    FxAgGridDateEditorComponent.prototype.afterGuiAttached = function () {
        var _this = this;
        var valueChange = function (value) {
            // if ( this.params.onChange !== undefined) {
            //  this.params.onChange(value);  // Added by David Lee 值发生变化时回调
            // }
            // 通过订阅消息回传onChangeField事件
            _this.formControl.setValue(value);
            _this.formControl.markAsDirty({ onlySelf: true });
        };
        this.cellInput.registerOnChange(valueChange); // Added by David Lee 注册OnChange事件
        this.flag = true;
        this.cellInput.onOpenChange = function () {
            if (_this.eventHandler) {
                if (_this.flag === true) {
                    _this.eventHandler.onBeforeField({
                        gridId: _this.params.context.id,
                        value: _this.formControl.value,
                        rowIndex: _this.params.node.rowIndex,
                        id: _this.params.node.id,
                        colId: _this.colId,
                        controlName: _this.name
                    });
                    _this.flag = false;
                }
            }
        };
        this.cellInput.onValueChange = function (value) {
            if (_this.eventHandler) {
                _this.eventHandler.onChangeField({
                    gridId: _this.params.context.id,
                    // value: this.formControl.value,
                    value: value ? value.nativeDate : null,
                    rowIndex: _this.params.node.rowIndex,
                    id: _this.params.node.id,
                    colId: _this.colId,
                    controlName: _this.name
                });
            }
            _this.cellInput.closeOverlay();
            if (_this.eventHandler) {
                _this.eventHandler.onAfterField({
                    gridId: _this.params.context.id,
                    // value: this.formControl.value,
                    value: value ? value.nativeDate : null,
                    rowIndex: _this.params.node.rowIndex,
                    id: _this.params.node.id,
                    colId: _this.colId,
                    controlName: _this.name
                });
            }
        };
    };
    FxAgGridDateEditorComponent.prototype.focusIn = function () {
        if (this.eventHandler) {
            this.eventHandler.onBeforeField({
                gridId: this.params.context.id,
                value: this.formControl.value,
                rowIndex: this.params.node.rowIndex,
                id: this.params.node.id,
                colId: this.colId,
                controlName: this.name
            });
        }
    };
    FxAgGridDateEditorComponent.prototype.focusOut = function () {
        if (this.eventHandler) {
            this.eventHandler.onAfterField({
                gridId: this.params.context.id,
                value: this.formControl.value,
                rowIndex: this.params.node.rowIndex,
                id: this.params.node.id,
                colId: this.colId,
                controlName: this.name
            });
        }
    };
    FxAgGridDateEditorComponent.prototype.isCancelAfterEnd = function () {
        return this.validationMessages.length > 0;
    };
    FxAgGridDateEditorComponent.prototype.isCancelBeforeStart = function () {
        return false;
    };
    FxAgGridDateEditorComponent.prototype.isPopup = function () {
        return false;
    };
    FxAgGridDateEditorComponent.prototype.ngOnDestroy = function () {
        this.validateForm.removeControl(this.name);
        // 当销毁时取消所有订阅
        if (this.valueSetSubscription) {
            this.valueSetSubscription.unsubscribe();
        }
    };
    return FxAgGridDateEditorComponent;
}(FxAgGridValidationEditorComponent));
export { FxAgGridDateEditorComponent };
